import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const sendInvoice = {
    namespaced: true,
    state: {
        dataSendIsFetching: [],
        snackbarData: [],
        invoice: {},
        emailIsSending: false,
    },
    mutations: {
        DATA_SAVE_REQUEST(state, item) {
            state.dataSendIsFetching.push(item);
            state.emailIsSending = true;
        },
        DATA_SAVE_SUCCESS(state, response, item) {
            state.snackbarData = {
                title: response.data.message,
                message: response.data.data.textInfo,
            };
            state.dataSendIsFetching.splice(state.dataSendIsFetching.indexOf(item), 1);
            state.emailIsSending = false;
            eventBus.$emit("sendInvoiceSuccess", state.snackbarData);
        },
        DATA_SAVE_FAILURE(state, error, item) {
            state.snackbarData = {
                title: error.response.data.message,
                message: handleError(error) !== "" ? handleError(error) : error.response.data.data.message
            }
            state.dataSendIsFetching.splice(state.dataSendIsFetching.indexOf(item), 1);
            state.emailIsSending = false;
            eventBus.$emit("sendInvoiceFailure", state.snackbarData);
        },
        PREPARE_INVOICE(state, item) {
            state.invoice = item;
        }
    },
    actions: {
        sendInvoice: function({ dispatch }, payload) {
            let clientPersonId = payload.creds.clientPerson === undefined ? null : payload.creds.clientPerson.id;
            let invoiceId = payload.creds.invoice.id;
            let email = payload.creds.email;
            let data = {
                clientPerson: clientPersonId,
                invoice: invoiceId,
                email: email
            }
            let person = payload.creds.favoriteContact === undefined ? payload.creds.clientPerson : payload.creds.favoriteContact;
  
            dispatch("requestDataSend", person);
            let promise = sendRequest("post", config.baseURLApi + "/invoices/sendInvoice", {}, data, true);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSend", result[1], payload.creds.clientPerson);
                } else {
                    dispatch("failureDataSend", result[1], payload.creds.clientPerson);
                }
            });
        },
        prepareInvoice: function ({commit}, item) {
            commit("PREPARE_INVOICE", item)
        },
        requestDataSend: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataSend: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSend: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
    }
}

export default sendInvoice;